import { pictureSrcSet } from '@xshop/shared';

// An <img>'s source as the storefront writes it: a store upload carries the srcset of every width the resizer serves,
// with the sizes it shows at, so the browser fetches the smallest file that is sharp; any other address is left as it is.

/** How wide a lazy picture shows: its laid-out width where the browser can read it, else the screen. */
export const LAZY_SIZES = 'auto, 100vw';

/** How wide a thumbnail shows: small, whatever the screen. */
export const THUMB_SIZES = '120px';

// Gives an <img> its source, and the srcset and sizes when the picture is a store upload.
export function responsive(src: string, sizes: string): { src: string; srcSet?: string; sizes?: string } {
  const set = pictureSrcSet(src);
  return set ? { src, srcSet: set, sizes } : { src };
}
